import React, {useState, useEffect} from 'react';
import '../App.css';
import {CustomInput, ErrorText} from '../components/ui';
import CustomModal from '../components/customModal/customModal';
import ModalFooter from '../components/customModal/modalFooter';
import {createPlan, getAllPlans, updatePlan} from '../api/services';
import {toast} from 'react-toastify';
import {validateFormHandler} from '../utils/validations/validateForm';
const SuperAddPackage = ({onSuccess, isOpen, onCancel, pkg}) => {
  const [errors, setErrors] = useState({});
  const [features, setFeatures] = useState(['']);
  // :small_blue_diamond: Reset form whenever editing a new package
  useEffect(() => {
    if (pkg) {
      setFeatures(
        pkg.features && pkg.features.length > 0 ? pkg.features : ['']
      );
    } else {
      setFeatures(['']);
    }
    setErrors({});
  }, [pkg]);
  const handleFeatureChange = (index, value) => {
    const updated = [...features];
    updated[index] = value;
    setFeatures(updated);
  };
  const addFeature = () => setFeatures([...features, '']);
  const removeFeature = (index) =>
    setFeatures(features.filter((_, i) => i !== index));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const payload = {
      id: pkg?._id,
      name: formData.get('name'),
      price: Number(formData.get('price')),
      features: features.filter((f) => f.trim() !== ''),
    };
    const validationErrors = validateFormHandler({
      name: payload.name,
      price: payload.price,
      feature: payload.features,
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (pkg) {
      const arraysEqual = (a, b) =>
        a.length === b.length && a.every((val, i) => val === b[i]);
      const isChanged =
        pkg.name !== payload.name ||
        pkg.price !== payload.price ||
        !arraysEqual(pkg.features, payload.features);
      if (!isChanged) {
        toast.info('No changes detected');
        return;
      }
      await updatePlan(payload);
      onSuccess();
    } else {
      await createPlan(payload);
      onCancel();
      onSuccess();
    }
    onCancel();
  };
  return (
    <CustomModal
      modalTitle={pkg ? 'Update Package' : 'Make New Package'}
      isOpen={isOpen}
      onClose={onCancel}
    >
      <form onSubmit={handleSubmit}>
        <CustomInput
          label="Title"
          type="text"
          name="name"
          message={errors.name}
          defaultValue={pkg?.name || ''}
        />
        <CustomInput
          type="number"
          step="0.01" // 👈 allows 2 decimal places
          label="Price"
          name="price"
          message={errors.price}
          defaultValue={pkg?.price || ''}
        />
        <label className="block mb-2 font-medium">
          Features <span className="text-red-500">*</span>
        </label>
        {features.map((feature, index) => (
          <div key={index} className="flex gap-2 mb-2">
            <input
              type="text"
              value={feature}
              onChange={(e) => handleFeatureChange(index, e.target.value)}
              className="border p-2 rounded flex-1"
              placeholder={`Feature ${index + 1}`}
            />
            {index > 0 && (
              <button
                type="button"
                onClick={() => removeFeature(index)}
                className="px-4 py-1 bg-red-500 text-white rounded"
              >
                ✕
              </button>
            )}
          </div>
        ))}
        <ErrorText message={errors.feature} />
        <button
          type="button"
          onClick={addFeature}
          className="mt-1 py-2 px-6 bg-themeGradient text-white font-semibold rounded-md shadow-sm hover:bg-themeColor2"
        >
          + Add Feature
        </button>
        <ModalFooter onCancel={onCancel} />
      </form>
    </CustomModal>
  );
};
export default SuperAddPackage;
